<form (ngSubmit)="onSubmit()" #form="ngForm" column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
  <cap-content-header>
    <cap-title>
      {{ "meldungsempfaenger.suche" | translate }}
    </cap-title>
    <cap-title-functionbar>
      <button (click)="onNew()" class="btn btn-outline-primary btn-sm" type="button">
        <i class="fas fa-plus me-2"></i>{{ "functionbar.new" | translate }}
      </button>
    </cap-title-functionbar>
  </cap-content-header>
  <ul [activeId]="'searchStandard'" #nav="ngbNav" class="nav-tabs" ngbNav>
    <li [ngbNavItem]="'searchStandard'">
      <a ngbNavLink>{{ "Standardsuche" | translate }}</a>
      <ng-template id="standard" ngbNavContent>
        <cap-form-row column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
          <cap-form-control labelKey="meldungsempfaenger.bezeichnung">
            <input [(ngModel)]="searchRequest.bezeichnung" #bezeichnungInput appAutofocus id="bezeichnung" name="bezeichnung" type="text" />
          </cap-form-control>
          <cap-form-control labelKey="meldungsempfaenger.erhaeltmeldungen">
            <select [(ngModel)]="searchRequest.erhaeltMeldungen" name="erhaeltMeldungen">
              <option [ngValue]="undefined"></option>
              <option [ngValue]="true">{{"JA" | translate}}</option>
              <option [ngValue]="false">{{"NEIN" | translate}}</option>
            </select>
          </cap-form-control>
        </cap-form-row>
        <cap-form-row column-classes="col-md-2,col-md-4,col-md-2,col-md-4">
          <cap-form-control labelKey="meldungsempfaenger.sedexid">
            <input [(ngModel)]="searchRequest.sedexId" id="sedexid" name="sedexid" type="text" />
          </cap-form-control>
          <cap-form-control labelKey="meldungsempfaenger.erhaeltVertraulicheDaten">
            <select [(ngModel)]="searchRequest.erhaeltVertraulicheDaten" name="erhaeltVertraulicheDaten">
              <option [ngValue]="undefined"></option>
              <option [ngValue]="true">{{"JA" | translate}}</option>
              <option [ngValue]="false">{{"NEIN" | translate}}</option>
            </select>
          </cap-form-control>
        </cap-form-row>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
  <cap-bsg-actionbar>
    <button (click)="onReset()" class="btn btn-outline-primary me-2" type="reset">{{ "actionbar.reset" | translate }}</button>
    <button [disabled]="!form.valid" class="btn btn-primary" type="submit">{{ "actionbar.search" | translate }}</button>
  </cap-bsg-actionbar>
</form>
